module.exports = __webpack_public_path__ + "static/media/online_btm_3.c1fbb8e7.png";